/* we-rock-visible 2026-09-18 */
(() => {
  function readI18n() {
    try {
      const el = document.getElementById('race-finder-i18n');
      if (el) return JSON.parse(el.textContent);
    } catch (err) {}
    return {};
  }
  const I18N = readI18n();
  function t(key, vars) {
    let s = I18N[key];
    if (s == null || s === '') s = key;
    if (vars) {
      Object.keys(vars).forEach((k) => {
        s = String(s).split('{{ ' + k + ' }}').join(String(vars[k]));
        s = String(s).split('{{' + k + '}}').join(String(vars[k]));
      });
    }
    return s;
  }
  function detectLocale() {
    const fromShopify = (window.Shopify && Shopify.locale) || '';
    const fromHtml = (document.documentElement && document.documentElement.lang) || '';
    const fromI18n = I18N.locale || '';
    const raw = (fromShopify || fromI18n || fromHtml || 'en').toLowerCase();
    return raw.split('-')[0] || 'en';
  }
  const LOCALE = detectLocale();
  const DATE_LOCALE = LOCALE === 'es' ? 'es' : 'en-US';
  function rootUrl() {
    if (I18N.rootUrl) return I18N.rootUrl;
    if (window.Shopify && Shopify.routes && Shopify.routes.root) return Shopify.routes.root;
    return '/';
  }
  function withRoot(path) {
    const root = rootUrl();
    const clean = String(path || '').replace(/^\/+/, '');
    if (root === '/' || root === '') return '/' + clean;
    return root.replace(/\/+$/, '/') + clean;
  }

  const TYPE_LABEL = {
    desert: () => t('type_desert'),
    short_course: () => t('type_short_course'),
    rock: () => t('type_rock'),
    gp: () => t('type_gp'),
  };
  function typeLabel(type) {
    const fn = TYPE_LABEL[type];
    return fn ? fn() : type;
  }

  const SOCIAL_ICON = {
    facebook: '<svg focusable="false" aria-hidden="true" viewBox="0 0 30 30"><path d="M15 30C6.71572875 30 0 23.2842712 0 15 0 6.71572875 6.71572875 0 15 0c8.2842712 0 15 6.71572875 15 15 0 8.2842712-6.7157288 15-15 15zm3.2142857-17.1429611h-2.1428678v-2.1425646c0-.5852979.8203285-1.07160109 1.0714928-1.07160109h1.071375v-2.1428925h-2.1428678c-2.3564786 0-3.2142536 1.98610393-3.2142536 3.21449359v2.1425646h-1.0714822l.0032143 2.1528011 1.0682679-.0099086v7.499969h3.2142536v-7.499969h2.1428678v-2.1428925z" fill="currentColor" fill-rule="evenodd"></path></svg>',
    instagram: '<svg focusable="false" aria-hidden="true" viewBox="0 0 30 30"><path d="M15 30C6.71572875 30 0 23.2842712 0 15 0 6.71572875 6.71572875 0 15 0c8.2842712 0 15 6.71572875 15 15 0 8.2842712-6.7157288 15-15 15zm.0000159-23.03571429c-2.1823849 0-2.4560363.00925037-3.3131306.0483571-.8553081.03901103-1.4394529.17486384-1.9505835.37352345-.52841925.20532625-.9765517.48009406-1.42331254.926823-.44672894.44676084-.72149675.89489329-.926823 1.42331254-.19865961.5111306-.33451242 1.0952754-.37352345 1.9505835-.03910673.8570943-.0483571 1.1307457-.0483571 3.3131306 0 2.1823531.00925037 2.4560045.0483571 3.3130988.03901103.8553081.17486384 1.4394529.37352345 1.9505835.20532625.5284193.48009406.9765517.926823 1.4233125.44676084.446729.89489329.7214968 1.42331254.9268549.5111306.1986278 1.0952754.3344806 1.9505835.3734916.8570943.0391067 1.1307457.0483571 3.3131306.0483571 2.1823531 0 2.4560045-.0092504 3.3130988-.0483571.8553081-.039011 1.4394529-.1748638 1.9505835-.3734916.5284193-.2053581.9765517-.4801259 1.4233125-.9268549.446729-.4467608.7214968-.8948932.9268549-1.4233125.1986278-.5111306.3344806-1.0952754.3734916-1.9505835.0391067-.8570943.0483571-1.1307457.0483571-3.3130988 0-2.1823849-.0092504-2.4560363-.0483571-3.3131306-.039011-.8553081-.1748638-1.4394529-.3734916-1.9505835-.2053581-.52841925-.4801259-.9765517-.9268549-1.42331254-.4467608-.44672894-.8948932-.72149675-1.4233125-.926823-.5111306-.19865961-1.0952754-.33451242-1.9505835-.37352345-.8570943-.03910673-1.1307457-.0483571-3.3130988-.0483571zm0 1.44787387c2.1456068 0 2.3997686.00819774 3.2471022.04685789.7834742.03572556 1.2089592.1666342 1.4921162.27668167.3750864.14577303.6427729.31990322.9239522.60111439.2812111.28117926.4553413.54886575.6011144.92395217.1100474.283157.2409561.708642.2766816 1.4921162.0386602.8473336.0468579 1.1014954.0468579 3.247134 0 2.1456068-.0081977 2.3997686-.0468579 3.2471022-.0357255.7834742-.1666342 1.2089592-.2766816 1.4921162-.1457731.3750864-.3199033.6427729-.6011144.9239522-.2811793.2812111-.5488658.4553413-.9239522.6011144-.283157.1100474-.708642.2409561-1.4921162.2766816-.847206.0386602-1.1013359.0468579-3.2471022.0468579-2.1457981 0-2.3998961-.0081977-3.247134-.0468579-.7834742-.0357255-1.2089592-.1666342-1.4921162-.2766816-.37508642-.1457731-.64277291-.3199033-.92395217-.6011144-.28117927-.2811793-.45534136-.5488658-.60111439-.9239522-.11004747-.283157-.24095611-.708642-.27668167-1.4921162-.03866015-.8473336-.04685789-1.1014954-.04685789-3.2471022 0-2.1456386.00819774-2.3998004.04685789-3.247134.03572556-.7834742.1666342-1.2089592.27668167-1.4921162.14577303-.37508642.31990322-.64277291.60111439-.92395217.28117926-.28121117.54886575-.45534136.92395217-.60111439.283157-.11004747.708642-.24095611 1.4921162-.27668167.8473336-.03866015 1.1014954-.04685789 3.247134-.04685789zm0 9.26641182c-1.479357 0-2.6785873-1.1992303-2.6785873-2.6785555 0-1.479357 1.1992303-2.6785873 2.6785873-2.6785873 1.4793252 0 2.6785555 1.1992303 2.6785555 2.6785873 0 1.4793252-1.1992303 2.6785555-2.6785555 2.6785555zm0-6.8050167c-2.2790034 0-4.1264612 1.8474578-4.1264612 4.1264612 0 2.2789716 1.8474578 4.1264294 4.1264612 4.1264294 2.2789716 0 4.1264294-1.8474578 4.1264294-4.1264294 0-2.2790034-1.8474578-4.1264612-4.1264294-4.1264612zm5.2537621-.1630297c0-.532566-.431737-.96430298-.964303-.96430298-.532534 0-.964271.43173698-.964271.96430298 0 .5325659.431737.964271.964271.964271.532566 0 .964303-.4317051.964303-.964271z" fill="currentColor" fill-rule="evenodd"></path></svg>',
    youtube: '<svg focusable="false" aria-hidden="true" viewBox="0 0 30 30"><path d="M15 30c8.2842712 0 15-6.7157288 15-15 0-8.28427125-6.7157288-15-15-15C6.71572875 0 0 6.71572875 0 15c0 8.2842712 6.71572875 15 15 15zm7.6656364-18.7823145C23 12.443121 23 15 23 15s0 2.5567903-.3343636 3.7824032c-.184.6760565-.7260909 1.208492-1.4145455 1.3892823C20.0033636 20.5 15 20.5 15 20.5s-5.00336364 0-6.25109091-.3283145c-.68836364-.1807903-1.23054545-.7132258-1.41454545-1.3892823C7 17.5567903 7 15 7 15s0-2.556879.33436364-3.7823145c.184-.6761452.72618181-1.2085807 1.41454545-1.38928227C9.99663636 9.5 15 9.5 15 9.5s5.0033636 0 6.2510909.32840323c.6884546.18070157 1.2305455.71313707 1.4145455 1.38928227zm-9.302 6.103758l4.1818181-2.3213548-4.1818181-2.3215322v4.642887z" fill="currentColor" fill-rule="evenodd"></path></svg>',
  };

  const SHARE_ICON = {
    email: '<svg focusable="false" aria-hidden="true" viewBox="0 0 28 28"><path fill="currentColor" fill-rule="evenodd" d="M14 28C6.2680135 28 0 21.7319865 0 14S6.2680135 0 14 0s14 6.2680135 14 14-6.2680135 14-14 14zm-3.2379501-18h6.4759002L14 12.6982917 10.7620499 10zM19 11.1350416V18H9v-6.8649584l5 4.1666667 5-4.1666667zM21 8H7v12h14V8z"></path></svg>',
    facebook: SOCIAL_ICON.facebook,
    instagram: SOCIAL_ICON.instagram,
    tiktok: '<svg focusable="false" aria-hidden="true" viewBox="0 0 30 30"><path fill-rule="evenodd" clip-rule="evenodd" d="M30 15c0 8.284-6.716 15-15 15-8.284 0-15-6.716-15-15C0 6.716 6.716 0 15 0c8.284 0 15 6.716 15 15zm-7.902-1.966c.133 0 .267-.007.4-.02h.002v-2.708a4.343 4.343 0 01-4.002-3.877h-2.332l-.024 11.363c0 1.394-1.231 2.493-2.625 2.493a2.524 2.524 0 010-5.048c.077 0 .152.01.227.02l.078.01v-2.436a3.334 3.334 0 00-.306-.016 4.945 4.945 0 104.946 4.945v-6.69a4.345 4.345 0 003.636 1.964z" fill="currentColor"></path></svg>',
    x: '<svg focusable="false" aria-hidden="true" viewBox="0 0 30 30"><path fill-rule="evenodd" clip-rule="evenodd" d="M30 15c0 8.284-6.716 15-15 15-8.284 0-15-6.716-15-15C0 6.716 6.716 0 15 0c8.284 0 15 6.716 15 15Zm-8.427-7h-2.375l-3.914 4.473L11.901 8H7l5.856 7.657L7.306 22h2.376l4.284-4.894L17.709 22h4.78l-6.105-8.07L21.573 8ZM19.68 20.578h-1.316L9.774 9.347h1.412l8.494 11.231Z" fill="currentColor"></path></svg>',
    threads: '<svg focusable="false" aria-hidden="true" viewBox="0 0 30 30"><path fill-rule="evenodd" clip-rule="evenodd" d="M30 15c0 8.284-6.716 15-15 15-8.284 0-15-6.716-15-15C0 6.716 6.716 0 15 0c8.284 0 15 6.716 15 15Zm-11.186-.764c.08.034.159.07.236.107 1.096.525 1.898 1.321 2.318 2.302.586 1.366.64 3.592-1.138 5.369-1.359 1.357-3.008 1.97-5.348 1.986h-.011c-2.632-.018-4.656-.904-6.016-2.632-1.21-1.539-1.834-3.679-1.855-6.362v-.012c.021-2.683.645-4.823 1.855-6.362C10.215 6.904 12.24 6.018 14.871 6h.01c2.638.018 4.685.9 6.084 2.623.691.85 1.198 1.873 1.521 3.062l-1.514.404c-.266-.966-.67-1.794-1.205-2.453-1.091-1.343-2.737-2.032-4.89-2.048-2.14.016-3.756.702-4.808 2.038-.984 1.252-1.493 3.06-1.512 5.374.019 2.314.528 4.122 1.512 5.373 1.052 1.337 2.669 2.023 4.807 2.039 1.928-.014 3.204-.473 4.265-1.533 1.21-1.21 1.188-2.695.8-3.598-.227-.531-.64-.973-1.196-1.31-.136 1.011-.443 1.813-.928 2.432-.64.815-1.555 1.26-2.723 1.324-.885.048-1.736-.165-2.396-.601-.782-.516-1.24-1.306-1.288-2.224-.097-1.81 1.34-3.112 3.572-3.24a9.876 9.876 0 0 1 2.22.106c-.09-.556-.275-.997-.55-1.317-.377-.438-.96-.663-1.734-.668h-.022c-.62 0-1.464.174-2 .989l-1.293-.886c.72-1.091 1.888-1.691 3.293-1.691h.032c2.348.015 3.747 1.48 3.886 4.04Zm-5.85 2.58c.05.941 1.067 1.38 2.046 1.325.958-.052 2.046-.428 2.231-2.744a7.654 7.654 0 0 0-1.628-.166c-.178 0-.359.006-.543.016-1.61.093-2.143.871-2.106 1.57Z" fill="currentColor"></path></svg>',
    whatsapp: '<svg focusable="false" aria-hidden="true" viewBox="0 0 30 30"><path fill="currentColor" fill-rule="evenodd" d="M15 30C6.716 30 0 23.284 0 15S6.716 0 15 0s15 6.716 15 15-6.716 15-15 15zm.1-21.2c-3.5 0-6.4 2.8-6.4 6.3 0 1.1.3 2.2.8 3.1L8.3 22l3.9-1.3c.9.5 1.9.8 2.9.8 3.5 0 6.4-2.8 6.4-6.3s-2.9-6.4-6.4-6.4zm3.6 8.9c-.2.5-1 .9-1.4 1-.4.1-.8.1-2.5-.5-2.1-.8-3.4-2.9-3.5-3.1-.1-.2-.9-1.2-.9-2.2s.6-1.6.8-1.8c.2-.2.4-.3.6-.3h.4c.1 0 .3 0 .4.3l.6 1.5c.1.2 0 .4-.1.5l-.3.4c-.1.1-.2.3-.1.4.3.6.8 1.2 1.4 1.6.5.4 1 .6 1.2.7.2.1.4.1.5-.1l.7-.8c.1-.2.4-.2.6-.1l1.6.8c.2.1.4.2.4.4 0 .1 0 .7-.5 1.2z"></path></svg>',
    copy: '<svg focusable="false" aria-hidden="true" viewBox="0 0 30 30"><path fill="currentColor" fill-rule="evenodd" d="M15 30C6.716 30 0 23.284 0 15S6.716 0 15 0s15 6.716 15 15-6.716 15-15 15zm-3.25-16.75A1.75 1.75 0 0113.5 11.5h7A1.75 1.75 0 0122.25 13.25v9A1.75 1.75 0 0120.5 24h-7a1.75 1.75 0 01-1.75-1.75v-9zm1.75 0v9h7v-9h-7zM10.25 15v-1.5H9.5A1.75 1.75 0 007.75 15.25v9A1.75 1.75 0 009.5 26h7.25v-1.5H9.5v-9.5h.75z"></path></svg>',
  };

  function socialLink(url, name, label) {
    if (!url) return '';
    return `<a class="race-event__social-link" href="${url}" target="_blank" rel="noopener" aria-label="${label}">${SOCIAL_ICON[name]}</a>`;
  }

  function shareControl(tag, icon, label, attrs) {
    return `<${tag} class="race-event__share-item" ${attrs}><span class="race-event__share-icon">${SHARE_ICON[icon]}</span><span class="race-event__share-label">${label}</span></${tag}>`;
  }

  function $(root, sel) {
    return root.querySelector(sel);
  }

  function todayISO() {
    // Brand calendar day in America/Phoenix (no DST). Inclusive end-of-day via end >= today.
    try {
      return new Intl.DateTimeFormat('en-CA', {
        timeZone: 'America/Phoenix',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      }).format(new Date());
    } catch (e) {
      const d = new Date();
      const m = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      return `${d.getFullYear()}-${m}-${day}`;
    }
  }

  function addDaysISO(iso, days) {
    const d = new Date(`${iso}T12:00:00`);
    d.setDate(d.getDate() + days);
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${d.getFullYear()}-${m}-${day}`;
  }

  function inWhen(event, when, today) {
    if (when === 'all') return true;
    if (when === 'past') return event.end < today;
    return event.end >= today;
  }

  function fillSelect(el, values) {
    const keep = el.value;
    el.querySelectorAll('option:not([value=""])').forEach((opt) => opt.remove());
    values.forEach((value) => {
      const opt = document.createElement('option');
      opt.value = value;
      opt.textContent = value;
      el.append(opt);
    });
    if ([...el.options].some((opt) => opt.value === keep)) el.value = keep;
    else el.value = '';
  }

  function fmtRange(start, end) {
    const a = new Date(`${start}T12:00:00`);
    const b = new Date(`${end}T12:00:00`);
    const opts = { month: 'short', day: 'numeric' };
    if (start === end) return a.toLocaleDateString(DATE_LOCALE, { ...opts, year: 'numeric' });
    if (a.getMonth() === b.getMonth() && a.getFullYear() === b.getFullYear()) {
      return `${a.toLocaleDateString(DATE_LOCALE, { month: 'short' })} ${a.getDate()}–${b.getDate()}, ${a.getFullYear()}`;
    }
    return `${a.toLocaleDateString(DATE_LOCALE, opts)} – ${b.toLocaleDateString(DATE_LOCALE, { ...opts, year: 'numeric' })}`;
  }

  function matches(event, filters) {
    const q = filters.q.trim().toLowerCase();
    const blob = [event.title, event.series, event.city, event.state, event.venue_name, event.venue_address]
      .join(' ')
      .toLowerCase();
    if (q && !blob.includes(q)) return false;
    if (filters.series && event.series !== filters.series) return false;
    if (filters.venue && venueName(event) !== filters.venue) return false;
    if (filters.state && event.state !== filters.state) return false;
    if (filters.region && event.region !== filters.region) return false;
    if (filters.type && event.type !== filters.type) return false;
    return true;
  }

  function venueName(event) {
    return event.venue_name || event.city || '';
  }


  function alertsPagePath() {
    return I18N.alertsPath || withRoot('pages/find-a-race-alerts');
  }

  function kebab(s) {
    return String(s || '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '');
  }

  function seriesId(seriesOrEvent) {
    const label = typeof seriesOrEvent === 'string' ? seriesOrEvent : (seriesOrEvent && seriesOrEvent.series);
    return kebab(label);
  }

  function venueId(event) {
    if (!event) return '';
    return kebab([event.venue_name, event.city, event.state].filter(Boolean).join('-'));
  }

  // Human strings for alerts form fill UX (watch_series / watch_venue text fields).
  function seriesLabel(seriesOrEvent) {
    if (typeof seriesOrEvent === 'string') return seriesOrEvent;
    return (seriesOrEvent && seriesOrEvent.series) || '';
  }

  function venueLabel(event) {
    if (!event) return '';
    const parts = [event.venue_name, event.city, event.state].filter(Boolean);
    if (parts.length >= 2) {
      // "venue_name, city, ST"
      if (event.venue_name && event.city && event.state) {
        return `${event.venue_name}, ${event.city}, ${event.state}`;
      }
      return parts.join(', ');
    }
    return venueName(event) || venueId(event);
  }

  function mapsDirectionsUrl(event) {
    if (!event) return '';
    const venue = String(event.venue_name || '').trim();
    if (venue) {
      const city = String(event.city || '').trim();
      const state = String(event.state || '').trim();
      const addr = String(event.venue_address || '').trim();
      const cityState = [city, state].filter(Boolean).join(', ');
      let query;
      if (addr && cityState && addr.length > cityState.length && addr.toLowerCase() !== cityState.toLowerCase()) {
        query = addr.toLowerCase().includes(venue.toLowerCase()) ? addr : `${venue}, ${addr}`;
      } else {
        query = [venue, city, state].filter(Boolean).join(', ');
      }
      return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`;
    }
    return event.maps_url || '';
  }

    function alertsPageUrl(parts) {
    const base = alertsPagePath();
    if (!base) return null;
    const q = new URLSearchParams();
    if (parts.series) q.set('series', parts.series);
    if (parts.event) q.set('event', parts.event);
    if (parts.venue) q.set('venue', parts.venue);
    if (parts.mode) q.set('mode', parts.mode);
    if (parts.season) q.set('season', parts.season);
    const qs = q.toString();
    return qs ? `${base}?${qs}` : base;
  }

  function alertsBtnHtml(href, label) {
    if (!href) return '';
    const text = label || t('get_notifications');
    return `<a class="race-finder__btn race-finder__btn--alerts" href="${href}">${text}</a>`;
  }

  function countryLabel(code) {
    if (code === 'MX') return t('country_mexico');
    if (code === 'US') return t('country_usa');
    return code || '';
  }

  function eventHref(event) {
    return withRoot(`pages/${encodeURIComponent(event.slug || '')}`);
  }

  function icsEscape(value) {
    return String(value || '').replace(/\\/g, '\\\\').replace(/;/g, '\\;').replace(/,/g, '\\,').replace(/\n/g, '\\n');
  }

  function ymd(iso) {
    return String(iso || '').replace(/-/g, '');
  }

  function dayAfter(iso) {
    const d = new Date(`${iso}T12:00:00`);
    d.setDate(d.getDate() + 1);
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${d.getFullYear()}-${m}-${day}`;
  }

  function buildIcs(event) {
    const stamp = new Date().toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, '');
    const loc = event.venue_address || [event.city, event.state].filter(Boolean).join(', ');
    const page = `https://bajaracinggear.com${eventHref(event)}`;
    const desc = [event.series, loc, event.official_url || event.url, page].filter(Boolean).join('\n');
    return [
      'BEGIN:VCALENDAR',
      'VERSION:2.0',
      'PRODID:-//Baja Racing Gear//Find a Race//EN',
      'CALSCALE:GREGORIAN',
      'METHOD:PUBLISH',
      'BEGIN:VEVENT',
      `UID:${event.slug || 'race'}@bajaracinggear.com`,
      `DTSTAMP:${stamp}`,
      `DTSTART;VALUE=DATE:${ymd(event.start)}`,
      `DTEND;VALUE=DATE:${ymd(dayAfter(event.end))}`,
      `SUMMARY:${icsEscape(event.title)}`,
      `LOCATION:${icsEscape(loc)}`,
      `DESCRIPTION:${icsEscape(desc)}`,
      `URL:${page}`,
      'END:VEVENT',
      'END:VCALENDAR',
    ].join('\r\n');
  }

  function downloadIcs(event) {
    const blob = new Blob([buildIcs(event)], { type: 'text/calendar;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${event.slug || 'race'}.ics`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 1500);
  }

  function sharePayload(event) {
    const url = `https://bajaracinggear.com${eventHref(event)}`;
    const loc = [event.city, event.state].filter(Boolean).join(', ');
    const slogan = t('share_slogan');
    const title = `${event.title || t('share_title_suffix')} | ${t('share_title_suffix')}`;
    const details = `${event.title} — ${event.series} — ${fmtRange(event.start, event.end)}${loc ? ` — ${loc}` : ''}`;
    const text = `${details}\n\n${slogan}`;
    return { url, title, text, details, slogan };
  }

  async function shareEvent(event, menu) {
    const { url, title, text } = sharePayload(event);
    if (navigator.share) {
      try {
        await navigator.share({ title, text, url });
        return;
      } catch (err) {
        if (err && err.name === 'AbortError') return;
      }
    }
  }

  function card(event) {
    const type = typeLabel(event.type);
    const country = countryLabel(event.country);
    return `<a class="race-finder__card" href="${eventHref(event)}" data-start="${event.start}">
      <p class="race-finder__kicker">${event.series} · ${type}</p>
      <h3 class="race-finder__title">${event.title}</h3>
      <p class="race-finder__meta">${fmtRange(event.start, event.end)}</p>
      <p class="race-finder__venue">${event.venue_name || event.city}</p>
      <p class="race-finder__addr">${event.venue_address || `${event.city}, ${event.state}`} · ${country}</p>
      <p class="race-finder__go">${t('event_details')}</p>
    </a>`;
  }

  function eventPage(event, calendarUrl) {
    const type = typeLabel(event.type);
    const country = countryLabel(event.country);
    const mapsHref = mapsDirectionsUrl(event) || event.maps_url || '';
    const maps = mapsHref
      ? `<a class="race-finder__btn" href="${mapsHref}" target="_blank" rel="noopener">${t('directions')}</a>`
      : '';
    const official = event.official_url || event.url
      ? `<a class="race-finder__btn" href="${event.official_url || event.url}" target="_blank" rel="noopener">${t('official_series_site')}</a>`
      : '';
    const results = event.results_url
      ? `<a class="race-finder__btn" href="${event.results_url}" target="_blank" rel="noopener">${t('official_results')}</a>`
      : '';
    const venueWeb = event.venue_url
      ? `<a class="race-finder__btn" href="${event.venue_url}" target="_blank" rel="noopener">${t('venue_website')}</a>`
      : '';
    const facebook = socialLink(event.facebook_url, 'facebook', t('facebook'));
    const instagram = socialLink(event.instagram_url, 'instagram', t('instagram'));
    const youtube = socialLink(event.youtube_url, 'youtube', t('youtube'));
    const social = facebook || instagram || youtube
      ? `<div class="race-event__links"><p class="race-event__links-label">${t('follow')}</p><div class="race-event__social">${facebook}${instagram}${youtube}</div></div>`
      : '';
    const addCal = `<button type="button" class="race-finder__btn race-finder__btn--live" data-add-calendar>${t('add_to_calendar')}</button>`;
    const payload = sharePayload(event);
    const mail = `mailto:?subject=${encodeURIComponent(payload.title)}&body=${encodeURIComponent(`${payload.text}\n${payload.url}`)}`;
    const facebookShare = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(payload.url)}`;
    const xShare = `https://twitter.com/intent/tweet?text=${encodeURIComponent(payload.text)}&url=${encodeURIComponent(payload.url)}`;
    const threadsShare = `https://www.threads.net/intent/post?text=${encodeURIComponent(`${payload.text} ${payload.url}`)}`;
    const whatsappShare = `https://api.whatsapp.com/send?text=${encodeURIComponent(`${payload.text}\n${payload.url}`)}`;
    const nativeShare = `<button type="button" class="race-finder__btn" data-share-event>${t('share_from_device')}</button>`;
    const caption = `${payload.text}
${payload.url}`;
    const shareBlock = `<div class="race-event__links"><p class="race-event__links-label">${t('share')}</p><div class="race-finder__actions">${nativeShare}</div>
      <div class="race-event__share-menu" data-share-menu>
      ${shareControl('a', 'email', t('email'), `href="${mail}"`)}
      ${shareControl('a', 'facebook', t('facebook'), `href="${facebookShare}" target="_blank" rel="noopener"`)}
      ${shareControl('button', 'instagram', t('instagram'), 'type="button" data-share-copy-open="https://www.instagram.com/"')}
      ${shareControl('button', 'tiktok', t('tiktok'), 'type="button" data-share-copy-open="https://www.tiktok.com/"')}
      ${shareControl('a', 'x', t('x'), `href="${xShare}" target="_blank" rel="noopener"`)}
      ${shareControl('a', 'threads', t('threads'), `href="${threadsShare}" target="_blank" rel="noopener"`)}
      ${shareControl('a', 'whatsapp', t('whatsapp'), `href="${whatsappShare}" target="_blank" rel="noopener"`)}
      ${shareControl('button', 'copy', t('copy_link'), 'type="button" data-copy-link')}
    </div></div>`;
    const notify = alertsBtnHtml(
      alertsPageUrl({
        series: seriesLabel(event.series),
        event: event.slug,
        venue: venueLabel(event),
        mode: 'event',
        season: '2026',
      }),
      t('get_notifications')
    );
    const links = `<div class="race-event__links"><p class="race-event__links-label">${t('get_there')}</p><div class="race-finder__actions">${addCal}${notify}${maps}${venueWeb}${official}${results}</div></div>`;
    return `<a class="race-event__back" href="${calendarUrl}">${t('back_to_calendar')}</a>
      <p class="race-finder__kicker">${event.series} · ${type}</p>
      <h1 class="race-finder__heading">${event.title}</h1>
      <p class="race-finder__meta">${fmtRange(event.start, event.end)}</p>
      <dl class="race-event__panel">
        <div class="race-event__row"><dt>${t('label_series')}</dt><dd>${(event.official_url || event.url) ? `<a class="race-event__series-link" href="${event.official_url || event.url}" target="_blank" rel="noopener">${event.series}</a>` : event.series}</dd></div>
        <div class="race-event__row"><dt>${t('label_type')}</dt><dd>${type}</dd></div>
        <div class="race-event__row"><dt>${t('label_dates')}</dt><dd>${fmtRange(event.start, event.end)}</dd></div>
        <div class="race-event__row"><dt>${t('label_venue')}</dt><dd>${event.venue_url ? `<a class="race-event__venue-link" href="${event.venue_url}" target="_blank" rel="noopener">${event.venue_name || event.city}</a>` : (event.venue_name || event.city)}</dd></div>
        <div class="race-event__row"><dt>${t('label_location')}</dt><dd>${event.venue_address || `${event.city}, ${event.state}`}</dd></div>
        <div class="race-event__row"><dt>${t('label_city')}</dt><dd>${event.city}, ${event.state} · ${country}</dd></div>
      </dl>
      ${links}
      ${shareBlock}
      ${social}`;
  }

  const MERCH_FALLBACK = {
    rock: ['pci-comlink-10-elite-race', 'raceair-pro', 'mobile-radio-chase-package', 'trax-communications-package'],
    desert: ['trax-communications-package', 'pci-comlink-10-elite-race', 'mobile-radio-chase-package', 'raceair-pro'],
    default: ['trax-communications-package', 'pci-comlink-10-elite-race', 'mobile-radio-chase-package', 'raceair-pro'],
  };

  function viewedIds() {
    try {
      const items = JSON.parse(localStorage.getItem('recentlyViewedProducts') || '[]');
      return Array.isArray(items) ? items.filter(Boolean).slice(0, 6) : [];
    } catch (err) {
      return [];
    }
  }

  function productImg(product) {
    const img = product.featured_image;
    if (typeof img === 'string') return img.startsWith('//') ? `https:${img}` : img;
    if (img && img.src) return img.src;
    if (product.images && product.images[0]) {
      const first = product.images[0];
      return typeof first === 'string' ? (first.startsWith('//') ? `https:${first}` : first) : (first.src || '');
    }
    return '';
  }

  function productMoney(product) {
    let n = product.price;
    if (typeof n === 'string') n = parseFloat(n);
    if (!Number.isFinite(n)) return '';
    if (n >= 1000 && Number.isInteger(n)) n /= 100;
    return `$${n.toLocaleString(DATE_LOCALE, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  }

  function merchCard(product) {
    const handle = product.handle;
    if (!handle) return '';
    const href = `/products/${handle}`;
    const img = productImg(product);
    const title = product.title || handle;
    const price = productMoney(product);
    return `<a class="race-finder__merch-card" href="${href}">
      ${img ? `<img src="${img}" alt="" width="320" height="320" loading="lazy">` : ''}
      <p class="race-finder__merch-title">${title}</p>
      <p class="race-finder__merch-price">${price}</p>
    </a>`;
  }

  function merchBanner(product) {
    const handle = product.handle;
    if (!handle) return '';
    const href = `/products/${handle}`;
    const img = productImg(product);
    const title = product.title || handle;
    const price = productMoney(product);
    return `<a class="race-finder__banner" href="${href}">
      ${img ? `<img src="${img}" alt="" width="280" height="280" loading="lazy">` : ''}
      <p class="race-finder__banner-title">${title}</p>
      <p class="race-finder__banner-price">${price}</p>
    </a>`;
  }

  async function fetchHandle(handle) {
    const res = await fetch(`/products/${handle}.js`, { credentials: 'same-origin' });
    if (!res.ok) return null;
    return res.json();
  }

  async function loadMerch(root, raceType) {
    const left = $(root, '[data-race-rail-left]');
    const right = $(root, '[data-race-rail-right]');
    const box = $(root, '[data-race-merch]');
    if (!box && !left && !right) return;
    let products = [];
    const ids = viewedIds();
    if (ids.length) {
      try {
        const rec = await fetch(`/recommendations/products.json?product_id=${encodeURIComponent(ids[0])}&limit=4`, { credentials: 'same-origin' }).then((r) => r.json());
        products = rec.products || [];
      } catch (err) {
        products = [];
      }
    }
    if (!products.length) {
      const handles = MERCH_FALLBACK[raceType] || MERCH_FALLBACK.default;
      products = (await Promise.all(handles.map(fetchHandle))).filter(Boolean);
    }
    const picked = products.slice(0, 4);
    if (!picked.length) return;
    if (left || right) {
      const a = picked.slice(0, 2).map(merchBanner).join('');
      const b = picked.slice(2, 4).map(merchBanner).join('');
      if (left && a) {
        left.hidden = false;
        left.innerHTML = a;
      }
      if (right && b) {
        right.hidden = false;
        right.innerHTML = b;
      }
    }
    if (!box) return;
    const cards = picked.map(merchCard).join('');
    if (!cards) return;
    box.hidden = false;
    box.innerHTML = `<div class="race-finder__merch-grid">${cards}</div>`;
  }

  function monthGrid(year, month, events) {
    const first = new Date(year, month, 1);
    const startDow = first.getDay();
    const daysInMonth = new Date(year, month + 1, 0).getDate();
    const hits = {};
    events.forEach((event) => {
      const a = new Date(`${event.start}T12:00:00`);
      const b = new Date(`${event.end}T12:00:00`);
      for (let d = new Date(a); d <= b; d.setDate(d.getDate() + 1)) {
        if (d.getFullYear() === year && d.getMonth() === month) {
          const key = d.getDate();
          hits[key] = hits[key] || [];
          hits[key].push(event);
        }
      }
    });
    let html = `<div class="race-finder__dow"><span>${t('dow_sun')}</span><span>${t('dow_mon')}</span><span>${t('dow_tue')}</span><span>${t('dow_wed')}</span><span>${t('dow_thu')}</span><span>${t('dow_fri')}</span><span>${t('dow_sat')}</span></div><div class="race-finder__grid">`;
    for (let i = 0; i < startDow; i += 1) html += '<div class="race-finder__day is-empty"></div>';
    for (let day = 1; day <= daysInMonth; day += 1) {
      const list = hits[day] || [];
      const dots = list
        .slice(0, 3)
        .map((event) => `<span class="race-finder__dot race-finder__dot--${event.type}"></span>`)
        .join('');
      html += `<button type="button" class="race-finder__day${list.length ? ' has-events' : ''}" data-day="${day}">
        <span>${day}</span><span class="race-finder__dots">${dots}</span>
      </button>`;
    }
    html += '</div>';
    return { html, hits };
  }

  async function init(root) {
    const src = root.getAttribute('data-events-url');
    const res = await fetch(src, { credentials: 'same-origin' });
    const data = await res.json();
    const today = todayISO();
    const allEvents = data.events || [];
    const listEl = $(root, '[data-race-list]');
    const calEl = $(root, '[data-race-cal]');
    const monthLabel = $(root, '[data-race-month]');
    const countEl = $(root, '[data-race-count]');
    const q = $(root, '[data-filter-q]');
    const when = $(root, '[data-filter-when]');
    const series = $(root, '[data-filter-series]');
    const venue = $(root, '[data-filter-venue]');
    const state = $(root, '[data-filter-state]');
    const region = $(root, '[data-filter-region]');
    const type = $(root, '[data-filter-type]');
    const disclaimer = $(root, '[data-race-disclaimer]');
    if (disclaimer && data.disclaimer) disclaimer.textContent = data.disclaimer;

    let view = new Date();
    let dayHits = {};

    function timedEvents() {
      return allEvents.filter((event) => inWhen(event, when.value || 'upcoming', today));
    }

    function refreshDropdowns(pool) {
      fillSelect(series, [...new Set(allEvents.map((e) => e.series).filter(Boolean))].sort());
      fillSelect(venue, [...new Set(pool.map(venueName).filter(Boolean))].sort((a, b) => a.localeCompare(b)));
      fillSelect(state, [...new Set(pool.map((e) => e.state).filter(Boolean))].sort());
    }


    function syncAlertsButtons() {
      // 2026-10-07: series/venue buttons are ALWAYS visible. With a Series/Venue filter
      // selected they deep-link that value; with "All" they open the alerts chooser
      // preset to that mode (pick on the alerts page). Params match what
      // find-a-race-alerts reads: mode, series (label), venue ("venue_name, city, ST"), season.
      const digest = root.querySelector('[data-alerts-digest]');
      const seriesBtn = root.querySelector('[data-alerts-series]');
      const venueBtn = root.querySelector('[data-alerts-venue]');
      if (digest) {
        digest.href = alertsPageUrl({ mode: 'chooser', season: '2026' });
        digest.hidden = false;
      }
      if (seriesBtn) {
        seriesBtn.href = series.value
          ? alertsPageUrl({ series: series.value, mode: 'series', season: '2026' })
          : alertsPageUrl({ mode: 'series', season: '2026' });
        seriesBtn.hidden = false;
        seriesBtn.textContent = t('get_notifications_series');
        if (series.value) seriesBtn.setAttribute('title', series.value);
        else seriesBtn.removeAttribute('title');
      }
      if (venueBtn) {
        let vlabel = '';
        if (venue.value) {
          const match = allEvents.find((e) => venueName(e) === venue.value)
            || timedEvents().find((e) => venueName(e) === venue.value);
          vlabel = match ? venueLabel(match) : venue.value;
        }
        venueBtn.href = vlabel
          ? alertsPageUrl({ venue: vlabel, mode: 'venue', season: '2026' })
          : alertsPageUrl({ mode: 'venue', season: '2026' });
        venueBtn.hidden = false;
        venueBtn.textContent = t('get_notifications_venue');
        if (vlabel) venueBtn.setAttribute('title', vlabel);
        else venueBtn.removeAttribute('title');
      }
    }

    function filters() {
      return { q: q.value, series: series.value, venue: venue.value, state: state.value, region: region.value, type: type.value };
    }

    function byDate(a, b, newestFirst) {
      const dir = newestFirst ? -1 : 1;
      return dir * (a.start.localeCompare(b.start) || a.end.localeCompare(b.end)) || a.title.localeCompare(b.title);
    }

    function render() {
      const pool = timedEvents();
      refreshDropdowns(pool);
      const newestFirst = (when.value || 'upcoming') === 'past';
      const filtered = pool.filter((event) => matches(event, filters())).sort((a, b) => byDate(a, b, newestFirst));
      countEl.textContent = filtered.length === 1
        ? t('races_one', { count: filtered.length })
        : t('races_other', { count: filtered.length });
      listEl.innerHTML = filtered.map(card).join('') || `<p class="race-finder__empty">${t('empty')}</p>`;
      const grid = monthGrid(view.getFullYear(), view.getMonth(), filtered);
      dayHits = grid.hits;
      calEl.innerHTML = grid.html;
      monthLabel.textContent = view.toLocaleDateString(DATE_LOCALE, { month: 'long', year: 'numeric' });
      syncAlertsButtons();
    }

    calEl.addEventListener('click', (ev) => {
      const btn = ev.target.closest('[data-day]');
      if (!btn) return;
      const day = Number(btn.getAttribute('data-day'));
      const newestFirst = (when.value || 'upcoming') === 'past';
      const picked = (dayHits[day] || []).slice().sort((a, b) => byDate(a, b, newestFirst));
      if (!picked.length) return;
      listEl.innerHTML = picked.map(card).join('');
      countEl.textContent = t('races_on_day', {
        count: picked.length,
        month: view.toLocaleDateString(DATE_LOCALE, { month: 'short' }),
        day,
      });
    });

    $(root, '[data-month-prev]').addEventListener('click', () => {
      view = new Date(view.getFullYear(), view.getMonth() - 1, 1);
      render();
    });
    $(root, '[data-month-next]').addEventListener('click', () => {
      view = new Date(view.getFullYear(), view.getMonth() + 1, 1);
      render();
    });
    [q, venue, state, region, type].forEach((el) => el.addEventListener('input', render));
    series.addEventListener('input', () => {
      const chosen = series.value;
      if (chosen) {
        const upcoming = allEvents.filter((e) => e.series === chosen && e.end >= today);
        if (!upcoming.length) {
          when.value = 'past';
          const past = allEvents.filter((e) => e.series === chosen).sort((a, b) => a.start.localeCompare(b.start));
          if (past.length) view = new Date(`${past[past.length - 1].end}T12:00:00`);
        }
      }
      render();
    });
    when.addEventListener('input', () => {
      const pool = timedEvents().slice().sort((a, b) => a.start.localeCompare(b.start));
      if (when.value === 'past' && pool.length) {
        const last = pool[pool.length - 1];
        view = new Date(`${last.end}T12:00:00`);
      } else {
        view = new Date();
      }
      render();
    });
    (function applyParams() {
      const params = new URLSearchParams(window.location.search);
      const wantWhen = params.get('when');
      const wantSeries = params.get('series');
      if (wantWhen && [...when.options].some((opt) => opt.value === wantWhen)) when.value = wantWhen;
      fillSelect(series, [...new Set(allEvents.map((e) => e.series).filter(Boolean))].sort());
      if (wantSeries && [...series.options].some((opt) => opt.value === wantSeries)) series.value = wantSeries;
      if (series.value) {
        const upcoming = allEvents.filter((e) => e.series === series.value && inWhen(e, 'upcoming', today));
        if (!upcoming.length) {
          when.value = 'past';
          const past = allEvents.filter((e) => e.series === series.value).sort((a, b) => a.start.localeCompare(b.start));
          if (past.length) view = new Date(`${past[past.length - 1].end}T12:00:00`);
        }
      }
    })();
    render();
    loadMerch(root, type && type.value).catch(() => {});
  }

  async function initEvent(root) {
    const src = root.getAttribute('data-events-url');
    const calendarUrl = root.getAttribute('data-calendar-url') || I18N.calendarPath || withRoot('pages/find-a-race');
    const body = $(root, '[data-race-event-body]');
    const qSlug = new URLSearchParams(window.location.search).get('e');
    const pathHandle = window.location.pathname.replace(/\/+$/, '').split('/').pop();
    const slug = qSlug || (pathHandle && pathHandle !== 'race' ? pathHandle : null);
    const res = await fetch(src, { credentials: 'same-origin' });
    const data = await res.json();
    const event = (data.events || []).find((item) => item.slug === slug);
    if (!event) {
      body.innerHTML = `<a class="race-finder__btn" href="${calendarUrl}">${t('back_to_calendar_btn')}</a><h1 class="race-finder__heading">${t('race_not_found')}</h1><p class="race-finder__subheading">${t('race_not_found_sub')}</p>`;
      return;
    }
    document.title = `${event.title} | ${t('document_title_suffix')}`;
    body.innerHTML = eventPage(event, calendarUrl);
    const addCal = body.querySelector('[data-add-calendar]');
    if (addCal) addCal.addEventListener('click', () => downloadIcs(event));
    const shareBtn = body.querySelector('[data-share-event]');
    const shareMenu = body.querySelector('[data-share-menu]');
    if (shareBtn) shareBtn.addEventListener('click', () => shareEvent(event, shareMenu));
    const copyBtn = body.querySelector('[data-copy-link]');
    if (copyBtn) {
      copyBtn.addEventListener('click', async () => {
        try {
          await navigator.clipboard.writeText(sharePayload(event).url);
          const label = copyBtn.querySelector('.race-event__share-label');
          if (label) label.textContent = t('copied');
        } catch (err) {
          const label = copyBtn.querySelector('.race-event__share-label');
          if (label) label.textContent = t('copy_failed');
        }
      });
    }
    body.querySelectorAll('[data-share-copy-open]').forEach((btn) => {
      btn.addEventListener('click', async () => {
        const dest = btn.getAttribute('data-share-copy-open');
        const payload = sharePayload(event);
        try {
          await navigator.clipboard.writeText(`${payload.text}
${payload.url}`);
        } catch (err) {}
        if (dest) window.open(dest, '_blank', 'noopener');
      });
    });
    loadMerch(root, event.type).catch(() => {});
  }

  document.querySelectorAll('[data-race-finder]').forEach((root) => {
    init(root).catch(() => {
      const list = root.querySelector('[data-race-list]');
      if (list) list.textContent = t('load_error');
    });
  });
  document.querySelectorAll('[data-race-event]').forEach((root) => {
    initEvent(root).catch(() => {
      const body = root.querySelector('[data-race-event-body]');
      if (body) body.textContent = t('event_load_error');
    });
  });
})();
